export default __webpack_public_path__ + "static/media/151-reading-glasses.7ac5b148.png";